import moment from "moment";
import { tr } from "@/utils/constants";
import store from "@/store/store";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export function addHours(date, h) {
  return moment(new Date(new Date(date).getTime() + h * 60 * 60 * 1000)).format(tr.hourToDateFormat);
  // formatDateWithHours(new Date(new Date(date).getTime() + h * 60 * 60 * 1000));
}

export function formatDateToHourV2(value, timezone = "UTC") {
  if (value != null) {
    return dayjs(value).tz(timezone).format(tr.dateToHourFormat);
  } else {
    return null;
  }
}
export function setStringSubstring(text, startWordIndex, endWordIndex) {
  let result = "";
  let splitText = text.split(" ");

  splitText.forEach((word, index) => {
    if (index >= startWordIndex && index <= endWordIndex) result += " " + word;
  });

  if (splitText.length - 1 > endWordIndex) result += "...";

  return result;
}

export function checkValue(value) {
  if (value != null && value != undefined && value != "") return true;
  else return false;
}

export function formatDate(value) {
  if (value != null) return moment(value).format(tr.dateFormat);
  else return "null";
}

export function formatDateEditZone(date, zone, mustZone) {
  if (!date) return "null";
  else {
    if (date.split("Z").length > 0) date = date.split("Z")[0];
    let z = parseInt(zone.split(":")[0]);
    let m = parseInt(mustZone.split(":")[0]);

    let subs = Math.abs(z - m);

    let over = m > z ? subs : (subs *= -1);

    let now = new Date(date);

    now.setHours(now.getHours() + over);

    return moment(now).format(tr.dateToHourFormat);
  }
}

export function formatDateEdit(value) {
  if (value != null) return moment(value).format(tr.dateFormatEdit);
  else return "null";
}

export function formatDateWithHours(value) {
  if (value != null) return moment(value).format(tr.dateFormatWithHours);
  else return "null";
}

export function formatDateTimeLocal(value) {
  if (value != null) return moment(value).format(tr.dateTimeLocalFormat);
  else return "null";
}

export function formatDateTimeLocalEdit(value) {
  if (value != null) return moment(value).format(tr.hourToDateFormat);
  else return "null";
}

export function formatMessageDate(value) {
  moment.locale("tr");
  if (value != null) return moment(new Date(value)).format(tr.dateMessageFormat);
  else return "null";
}

export function formatHourToDate(value) {
  let valueSplit = value.split(":");
  let newDate = new Date();
  newDate.setHours(valueSplit[0]);
  newDate.setMinutes(valueSplit[1]);
  newDate.setSeconds("00");
  if (value != null) return moment(newDate).format(tr.hourToDateFormat);
  else return null;
}

export function formatDateToHour(value) {
  if (value != null) return moment(value).format(tr.dateToHourFormat);
  else return null;
}

export function getFormat(value) {
  if (value != null) return moment(value).creationData().format;
  else return null;
}

export function setPaginationDetails(co, totalRecords, totalPages) {
  if (co.withoutPagination != true && (store.state.pagination.totalPages != totalPages || store.state.pagination.totalRecords != totalRecords)) {
    let newPagination = Object.assign({}, store.state.pagination, {
      totalRecords: totalRecords,
      totalPages: totalPages,
    });
    store.dispatch("addPaginationTotals", Object.assign({}, newPagination));
  }
}

export function decode(filePath) {
  let atobData = atob(filePath.split(",")[1]);

  let ia = new Uint8Array(atobData.length);

  for (var i = 0; i < atobData.length; i++) {
    ia[i] = atobData.charCodeAt(i);
  }
  return ia;
}

export function setSnackbarSuccess(message) {
  store.dispatch("loadSnackbarSuccess", message);
}
export function setSnackbarError(message) {
  store.dispatch("loadSnackbarError", message);
}
